export enum HOME_PAGE_TYPE {
    HOME = 'HOME',
    BOOKING = 'BOOKING',
}
